import React, {ReactNode} from 'react';
import {useMedia} from "@hooks/ui/useMedia";
import MuiDatePickerDateStartEndSidebar from "@ui/datePicker/muiDatePicker/MuiDatePickerDateStartEndSidebar";
import DateSelectSideBar from "@ui/datePicker/DateSelectSideBar";
import {IDateStartEndContext} from "@ui/datePicker/hooks/types/dateStartEnd";
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps {
	dateStartEndContext: IDateStartEndContext,
	disabled?: boolean,
	format?: string,
	fullWidth?: boolean,
	inputFormat?: string
	hasTime?: boolean,
	hideTemplate?: boolean,
	sxContainer?: SxType
	children?: ReactNode
	showLabel?:boolean
	inlineTemplateKeys?: string[]
}

const SidebarDatePicker = ({
							   dateStartEndContext,
							   disabled,
							   format,
							   fullWidth,
							   inputFormat,
							   hasTime,
							   hideTemplate,
							   sxContainer,
							   children,
							   showLabel,
							   inlineTemplateKeys,
						   }: IProps) => {
	const {isDesktop} = useMedia()
	
	if (isDesktop) {
		return (
			<MuiDatePickerDateStartEndSidebar
				format={format}
				dateStart={dateStartEndContext.dateStart}
				onChangeDateStart={dateStartEndContext.setDateStart}
				dateEnd={dateStartEndContext.dateEnd}
				onChangeDateEnd={dateStartEndContext.setDateEnd}
				disabled={disabled}
				fullWidth={fullWidth}
				inputFormat={inputFormat}
				hasTime={hasTime}
				hideTemplate={hideTemplate}
				sxContainer={sxContainer}
				children={children}
				showLabel={showLabel}
				inlineTemplateKeys={inlineTemplateKeys}
			/>
		)
	}
	
	return (
		<DateSelectSideBar
			hasTime={hasTime}
			format={format}
			dateStart={dateStartEndContext.dateStart}
			onChangeDateStart={dateStartEndContext.setDateStart}
			dateEnd={dateStartEndContext.dateEnd}
			onChangeDateEnd={dateStartEndContext.setDateEnd}
			disabled={disabled}
			children={children}
		/>
	)
	
};

export default SidebarDatePicker;